<template>
  <v-content>

    <slot />

    <v-bottom-navigation
      grow
      fixed
      app
      color="primary"
    >
      <template v-for="(item,i) in menus">
        <v-btn :key="'menu'+i" :to="item.to">
          <span>{{ item.label }}</span>
          <v-icon>{{ item.icon }}</v-icon>
        </v-btn>
      </template>
    </v-bottom-navigation>

  </v-content>
</template>

<script>
export default {

  data: () => ({
    menus: [
      {
        label: 'Beranda',
        to: '/',
        icon: 'mdi-home-outline'
      },
      {
        label: 'Kamus',
        to: '/kamus',
        icon: 'mdi-book-open-outline'
      },
      {
        label: 'Jurnal',
        to: '/jurnal',
        icon: 'mdi-folder-outline'
      }
    ]
  })

}
</script>
